(function () {
  var STOQ_SELECTORS = [
    '.restock-rocket-button-container',
    '.restock-rocket-button-product',
    '.restock-rocket-button',
    '[class*="restock-rocket-button"]',
    '#bnexo-back-in-stock-anchor .restock-rocket-button-container'
  ].join(',');

  function syncHint(variant) {
    var fallback = document.querySelector('[data-bnexo-stoq-fallback]');
    if (!fallback || !variant) return;
    if (variant.available) {
      fallback.hidden = true;
      return;
    }
    toggleFallback();
  }

  function hasStoqWidget() {
    return !!document.querySelector(STOQ_SELECTORS);
  }

  function toggleFallback() {
    var fallback = document.querySelector('[data-bnexo-stoq-fallback]');
    if (!fallback) return;

    var stoqPresent = hasStoqWidget();
    fallback.hidden = stoqPresent;
    fallback.setAttribute('aria-hidden', stoqPresent ? 'true' : 'false');
    if (stoqPresent) {
      fallback.style.setProperty('display', 'none', 'important');
    } else {
      fallback.style.removeProperty('display');
    }
  }

  function initStoqPlacement() {
    if (!document.querySelector('.bnexo-product-page')) return;

    toggleFallback();

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      toggleFallback();
      if (hasStoqWidget() || attempts >= 40) {
        window.clearInterval(timer);
        toggleFallback();
      }
    }, 400);
  }

  document.addEventListener('restock-rocket:loaded', function () {
    toggleFallback();
  });
  document.addEventListener('DOMContentLoaded', initStoqPlacement);

  if (document.readyState !== 'loading') {
    initStoqPlacement();
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!document.querySelector('.bnexo-product-page')) return;

      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        syncHint(event.data.variant);
        window.setTimeout(toggleFallback, 100);
      });
    });
  }
})();
